/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./cloudProxy.vue?vue&type=template&id=381a36b5&scoped=true&"
import script from "./cloudProxy.vue?vue&type=script&lang=js&"
export * from "./cloudProxy.vue?vue&type=script&lang=js&"
import style0 from "./cloudProxy.vue?vue&type=style&index=0&id=381a36b5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381a36b5",
  null
  
)

export default component.exports